export const api_key = "CNCPLAaS4rpLQvcEltE2";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://api-staging-sdk-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") => new URL(url, "sdk-staging.carenow.healthcare");
